<template>
    <LoadingBar />
    <v-row>
        <v-col>
            <h1>{{ name || "&nbsp;" }}</h1>
        </v-col>
        <v-col class="d-flex ga-4 justify-end">
            <v-btn v-if="current.type === 'owner'" color="primary" variant="outlined"
                @click="navigateToJobOrderReport()">
                Job Order Report
            </v-btn>
            <v-btn v-if="current.type === 'project'" color="primary" variant="outlined"
                @click="navigateToProjectStatusReport()">
                Project Status Report
            </v-btn>
            <v-btn v-if="$hasPermission(`${current.type}:update`)" color="primary" variant="flat"
                @click="navigateToUpdate()">
                Update
            </v-btn>
            <v-btn
                v-if="($hasPermission(`${current.type}:delete`) && (
                    entityData?.core?.status === 'submitted' ||
                    entityData?.core?.status === 'pending' ||
                    (Array.isArray(entityData?.core?.status) && (entityData.core.status.includes('submitted') || entityData.core.status.includes('pending')))
                ))"
                color="red"
                variant="flat"
                @click="navigateToDelete()"
            >
                Delete
            </v-btn>
        </v-col>
    </v-row>
</template>
<script setup>
import { useStore } from 'vuex';
import { computed, defineProps, watch } from 'vue';
import { useRouter } from 'vue-router';
import LoadingBar from "@/components/interface/LoadingBar.vue";
const router = useRouter();
const props = defineProps(['current']);
const store = useStore();
console.log("ReadHeader view 'current' prop:", props.current);
const entityData = computed(() => store.getters.getEntityDocument(props.current.id));
watch(entityData, (newVal) => {
    if (newVal) {
        console.log("ReadHeader view entity data:", newVal);
    }
}, { immediate: true });


const name = computed(() => {
    return store.getters.getEntityDocument(props.current.id)?._name;
})

function navigateToUpdate() {
    router.push(`/${props.current.type}/${props.current.id}/update`);
}
function navigateToDelete() {
    router.push(`/${props.current.type}/${props.current.id}/delete`);
}
function navigateToProjectStatusReport() {
    router.push(`/project-status-report/${props.current.id}`);
}
function navigateToJobOrderReport() {
    router.push(`/job-order-report/${props.current.id}`);
}
</script>